import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Nav, NavItem, NavDropdown, MenuItem, Label } from "react-bootstrap";
import { navigate } from "raviger";
import _ from "lodash";
import * as constants from "../../constants";

import { breadcrumbRemoveAllRoutes } from "../../store/actions/breadcrumb";

import "./SideMenu.css";

const menuItems = [
  {
    key: "dashboard",
    text: "Dashboard",
    href: "/dashboard",
    icon: "dashboard",
    permissions: [constants.PERMISSION_DASHBOARD],
  },
  {
    key: "instances",
    text: "Instances",
    href: "/instances",
    icon: "building",
    permissions: [constants.PERMISSION_FRANCHISES],
  },
  {
    key: "contracts",
    text: "Contracts",
    href: "/contracts",
    icon: "building",
    permissions: [constants.PERMISSION_CONTRACTS],
  },
  {
    key: "classes",
    text: "Classes",
    href: "/classes",
    icon: "graduation-cap",
    permissions: [constants.PERMISSION_CLASSES],
  },
  {
    key: "content",
    text: "Content",
    href: "/",
    icon: "list",
    permissions: [constants.PERMISSION_CONTENT],
    subItems: [
      {
        key: "popupNotices",
        text: "Popup Notices",
        href: "/announcements",
        icon: "bullhorn",
        permissions: [constants.PERMISSION_CONTENT_POPUPNOTICES],
      },
      {
        key: "companyNews",
        text: "Company News",
        href: "/companyNews",
        permissions: [constants.PERMISSION_CONTENT_COMPANYNEWS],
      },
      {
        key: "communicationGroups",
        text: "Communication Groups",
        href: "/communicationGroups",
        permissions: [constants.PERMISSION_CONTENT_COMMUNICATIONGROUPS],
      },
      {
        key: "globalFiles",
        text: "Documents",
        href: "/documents",
        permissions: [constants.PERMISSION_CONTENT_DOCUMENTS],
      },
      {
        key: "downloads",
        text: "Downloads",
        href: "/downloadInstances",
        permissions: [constants.PERMISSION_CONTENT_DOWNLOADS],
      },
      {
        key: "faqCategories",
        text: "FAQ Categories",
        href: "/faqCategories",
        permissions: [constants.PERMISSION_CONTENT_FAQCATEGORIES],
      },
      {
        key: "faqQuestions",
        text: "FAQ Questions",
        href: "/faqs",
        permissions: [constants.PERMISSION_CONTENT_FAQQUESTIONS],
      },
      {
        key: "activityPlans",
        text: "Activity Plans",
        href: "/activityPlans",
        permissions: [constants.PERMISSION_CONTENT_ACTIVITYPLANS],
      },
      {
        key: "mailMerge",
        text: "Mail Merge Templates",
        href: "/mailMerge",
        permissions: [constants.PERMISSION_CONTENT_MAILMERGETEMPLATES],
      },
      {
        key: "masterBlaster",
        text: "Master Blaster",
        href: "/services/instances/masterBlaster",
        permissions: [constants.PERMISSION_CONTENT_MASTERBLASTER],
      },
      {
        key: "smartDocsMapping",
        text: "SmartDocs Mapping",
        href: "/smartdocsMapping",
        permissions: [constants.PERMISSION_CONTENT_SMARTDOCS_MAPPING],
      },
      {
        key: "surveyTemplates",
        text: "Survey Templates",
        href: "/surveyTemplates",
        permissions: [constants.PERMISSION_CONTENT_SURVEYTEMPLATES],
      },
      {
        key: "videoCourses",
        text: "Video Courses",
        href: "/videoCourses",
        permissions: [constants.PERMISSION_CONTENT_VIDEOCOURSES],
      },
    ],
  },
  {
    key: "reports",
    text: "Reports",
    href: "/reports",
    icon: "pie-chart",
    permissions: [constants.PERMISSION_REPORTS],
    subItems: [
      {
        key: "viewReports",
        text: "View Reports",
        href: "/reports",
        permissions: [constants.PERMISSION_REPORTS_VIEWREPORTS],
      },
      {
        key: "manageReports",
        text: "Manage Reports",
        href: "/manageReports",
        permissions: [constants.PERMISSION_REPORTS_MANAGEREPORTS],
      },
      {
        key: "emailReports",
        text: "Emailed Reports",
        href: "/",
        icon: "list",
        permissions: [constants.PERMISSION_REPORTS],
        subItems: [
          {
            key: "brokerMetrics",
            text: "Broker Metrics",
            href: "/brokerMetrics",
            permissions: [constants.PERMISSION_REPORTS_BROKERMETRICS],
          },
          {
            key: "agentList",
            text: "Agent List Export",
            href: "/agentListExport",
            permissions: [constants.PERMISSION_REPORTS_AGENTLISTEXPORT],
          },
          {
            key: "sidesVolume",
            text: "Sides and Volume",
            href: "/sidesVolumeExport",
            permissions: [constants.PERMISSION_REPORTS_SIDESVOLUMEEXPORT],
          },
          {
            key: "transactionDetails",
            text: "Instance Transaction Details",
            href: "/transactionDetails",
            permissions: [constants.PERMISSION_REPORTS_TRANSACTIONDETAILS],
          },
        ],
      },
    ],
  },
  {
    key: "territories",
    text: "Territory Map",
    href: "/territories",
    icon: "map-marker",
    permissions: [constants.PERMISSION_TERRITORYMAP],
  },
  {
    key: "accounting",
    text: "Accounting",
    href: "/",
    icon: "money",
    permissions: [constants.PERMISSION_ACCOUNTING],
    subItems: [
      {
        key: "balanceDueUpload",
        text: "Balance Due Upload",
        href: "/accounting/balanceDueUpload",
        permissions: [constants.PERMISSION_ACCOUNTING_BALENCEDUEUPLOAD],
      },
      {
        key: "franchiseProducts",
        text: "Subscription/Fee Mapping",
        href: "/accounting/franchiseProductsTemplates",
        permissions: [constants.PERMISSION_ACCOUNTING_FRANCHISEPRODUCTS],
      },
    ],
  },
  {
    key: "marketplace",
    text: "Marketplace",
    href: "/",
    icon: "shopping-bag",
    permissions: [constants.PERMISSION_MARKETPLACE],
    subItems: [
      {
        key: "vendors",
        text: "Vendors",
        href: "/marketplace/vendors",
        permissions: [constants.PERMISSION_MARKETPLACE_VENDORS],
      },
      {
        key: "categories",
        text: "Categories",
        href: "/marketplace/categories",
        permissions: [constants.PERMISSION_MARKETPLACE_CATEGORIES],
      },
    ],
  },
  {
    key: "settings",
    text: "Settings",
    href: "/",
    icon: "cogs",
    permissions: [constants.PERMISSION_SETTINGS],
    subItems: [
      {
        key: "mlsProviders",
        text: "MLS Providers",
        href: "/mlsProviders",
        icon: "list",
        permissions: [constants.PERMISSION_SETTINGS_MLSPROVIDERS],
      },
      {
        key: "realEstateBoards",
        text: "Real Estate Boards",
        href: "/realEstateBoards",
        icon: "address-book",
        permissions: [constants.PERMISSION_SETTINGS_REALESTATEBOARDS],
      },
      {
        key: "royaltyPlanTemplates",
        text: "Royalty Plans",
        href: "/royaltyPlanTemplates",
        icon: "bank",
        permissions: [constants.PERMISSION_SETTINGS_ROYALTYPLANS],
      },
      {
        key: "features",
        text: "Features",
        href: "/features",
        icon: "gears",
        permissions: [constants.PERMISSION_SETTINGS_FEATURES],
      },
      {
        key: "fines",
        text: "Fines",
        href: "/fines",
        icon: "gears",
        permissions: [constants.PERMISSION_SETTINGS_FINES],
      },
      {
        key: "userManagement",
        text: "User Management",
        href: "/users",
        icon: "users",
        permissions: [constants.PERMISSION_SETTINGS_USERMANAGEMENT],
      },
      {
        key: "userRoles",
        text: "User Roles",
        href: "/userroles",
        icon: "users",
        permissions: [constants.PERMISSION_SETTINGS_FRANCHISEROLEMANAGEMENT],
      },
      {
        key: "rsaMenuSettings",
        text: "RSA Settings",
        href: "/rsaMenuSettings",
        icon: "users",
        permissions: [constants.PERMISSION_SETTINGS_RSA_MENU_SETTINGS],
      },
      {
        key: "globalSettings",
        text: "Global Settings",
        href: "/globalSettings",
        icon: "globe",
        permissions: [constants.PERMISSION_SETTINGS_GLOBALSETTINGS],
      },{
        key: "gmailGroups",
        text: "Gmail Groups",
        href: "/gmailGroups",
        icon: "globe",
        permissions: [constants.PERMISSION_SETTINGS_GmailGroups],
      },
      {
        key: "departmentOfRealEstate",
        text: "Department of Real Estate",
        href: "/departmentOfRealEstate",
        icon: "address-book",
        permissions: [constants.PERMISSION_SETTINGS_DEPARTMENTOFREALESTATE],
      },
    ],
  },
];

export default function SideMenu(props) {
  // Redux items
  const dispatch = useDispatch();

  const { permissions } = useSelector((state) => ({
    permissions: state.authentication.permissions,
  }));

  const redirect = (href) => {
    if (window.location.pathname !== href) {
      dispatch(breadcrumbRemoveAllRoutes());
    }

    navigate(href);
  };

  const items = menuItems
    .map((item) => {
      let menuClasses = "side-menu-item";
      let subMenuClasses = "side-sub-menu-item";
      let dropdownClasses = "side-sub-menu-item";
      if (item.key === props.activeKey) {
        menuClasses += " active";
      }

      if (!_.isEmpty(item.permissions) && _.isEmpty(permissions)) {
        return null;
      }
      if (
        !_.isEmpty(permissions) &&
        !_.isEmpty(item.permissions) &&
        !permissions.some((r) => item.permissions.includes(r.name))
      ) {
        return null;
      }

      if (item.subItems !== undefined && item.subItems.length > 0) {
        let subItemList = item.subItems
          .map((subItem) => {
            const betaLabel = subItem.beta ? (
              <>
                &nbsp;
                <Label bsStyle="danger">Beta</Label>
              </>
            ) : null;

            if (subItem.subItems !== undefined && subItem.subItems.length > 0) {
              let subsubItemList = subItem.subItems
                .map((subsubItem) => {
                  if (
                    !_.isEmpty(subsubItem.permissions) &&
                    _.isEmpty(permissions)
                  ) {
                    return null;
                  }
                  if (
                    !_.isEmpty(permissions) &&
                    !_.isEmpty(subsubItem.permissions) &&
                    !permissions.some((r) =>
                      subsubItem.permissions.includes(r.name)
                    )
                  ) {
                    return null;
                  }

                  return (
                    <MenuItem
                      key={subsubItem.key}
                      eventKey={subsubItem.key}
                      onClick={() => redirect(subsubItem.href)}
                      className={subMenuClasses}
                    >
                      {subsubItem.text}
                    </MenuItem>
                  );
                })
                .filter(Boolean);

              return (
                <NavDropdown
                  id={subItem.key}
                  key={subItem.key}
                  eventKey={subItem.key}
                  title={
                    <span>
                      {subItem.text} {betaLabel}
                      <span className="pull-right">
                        <i className="fa fa-caret-right"></i>
                      </span>
                    </span>
                  }
                  noCaret
                  className={dropdownClasses}
                >
                  {subsubItemList}
                </NavDropdown>
              );
            }

            if (!_.isEmpty(subItem.permissions) && _.isEmpty(permissions)) {
              return null;
            }
            if (
              !_.isEmpty(permissions) &&
              !_.isEmpty(subItem.permissions) &&
              !permissions.some((r) => subItem.permissions.includes(r.name))
            ) {
              return null;
            }

            return (
              <MenuItem
                key={subItem.key}
                eventKey={subItem.key}
                onClick={() => redirect(subItem.href)}
                className={subMenuClasses}
              >
                {subItem.text} {betaLabel}
              </MenuItem>
            );
          })
          .filter(Boolean);

        const betaLabel = item.beta ? (
          <React.Fragment>
            &nbsp;<Label bsStyle="danger">Beta</Label>
          </React.Fragment>
        ) : null;

        return (
          <NavDropdown
            id={item.key}
            key={item.key}
            eventKey={item.key}
            title={
              <span>
                <i className={`fa fa-${item.icon} button-icon`}></i>
                {item.text} {betaLabel}
                <span className="pull-right">
                  <i className="fa fa-caret-right"></i>
                </span>
              </span>
            }
            noCaret
            className={menuClasses}
          >
            {subItemList}
          </NavDropdown>
        );
      }

      const betaLabel = item.beta ? (
        <React.Fragment>
          &nbsp;<Label bsStyle="danger">Beta</Label>
        </React.Fragment>
      ) : null;

      return (
        <NavItem
          key={item.key}
          eventKey={item.key}
          onClick={() => redirect(item.href)}
          className={menuClasses}
        >
          <i className={`fa fa-${item.icon} button-icon`}></i>
          {item.text} {betaLabel}
        </NavItem>
      );
    })
    .filter(Boolean);

  return (
    <div className="side-menu-wrapper">
      <Nav bsStyle="pills" stacked className="side-menu">
        {items}
      </Nav>
    </div>
  );
}
